import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import CustomButton from "../Components/Button";
import {
  getMaterialOutwardData,
  updateMaterialOutwardStatus,
} from "./mutations/materialOutward";
import { useMutation, useQuery, useQueryClient } from "react-query";
import useAuth from "../../hooks/useAuth";
import { formatDate, formatTime } from "../../utils/formatDate";
import { handleToastMsg } from "../Components/Toast";
import Loader from "../Components/Loader";

function MaterialOutward() {
  const queryClient = useQueryClient();
  const { mutate: statusMutate, isLoading: statusLoader } = useMutation(
    updateMaterialOutwardStatus
  );
  const { auth } = useAuth();
  const { data: materialData } = useQuery(
    "get-material-outward",
    () => getMaterialOutwardData(),
    {
      onSuccess: (res) => {
        console.log({ res });
      },
      refetchOnMount: true,
    }
  );

  console.log({ materialData });

  const updateStatus = (id) => {
    statusMutate(id, {
      onSuccess: (res) => {
        console.log({ res });
        queryClient.invalidateQueries("get-material-outward");
        handleToastMsg("Data updated successfully", "success");
      },
    });
  };

  const isManagingDirector = auth?.roles.includes("MANAGING DIRECTOR");

  if (statusLoader) return <Loader />;

  return (
    <Grid container justifyContent={"center"}>
      <h4 style={{ textAlign: "center" }}>
        Materials Outward / வெளிச்செல்லும் பொருள்
      </h4>
      <Grid item container justifyContent={"center"} py={2}>
        <Table sx={{ width: 850 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Date / தேதி</TableCell>
              <TableCell>Reference No / குறிப்பு எண்</TableCell>
              <TableCell>Test Report No / அறிக்கை எண்</TableCell>
              <TableCell align="center">Time / நேரம்</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {materialData && materialData.length > 0 ? (
              materialData.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">{formatDate(row.date)}</TableCell>
                  <TableCell component="th" scope="row">
                    {row.invoiceNum}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.testReportNum}
                  </TableCell>
                  <TableCell align="right">{formatTime(row.time)}</TableCell>
                  <TableCell align="right">
                    {!isManagingDirector && (
                      <CustomButton onClick={() => updateStatus(row.id)}>
                        Out / வெளியே
                      </CustomButton>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <h4>No data found</h4>
            )}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
}

export default MaterialOutward;
